// Plan caps delivered with the session under `planLimits` (see AuthService).
// A missing value or -1 means unlimited, the same value the backend stores.

export function getPlanLimit(name) {
    try {
        const limits = JSON.parse(localStorage.getItem('planLimits') || '{}');
        const value = Number(limits[name]);
        return Number.isFinite(value) ? value : -1;
    } catch {
        return -1;
    }
}

export function isUnlimited(max) {
    return Number(max) === -1;
}

// True when `used` reached `max` (-1 never does).
export function isAtLimit(used, max) {
    if (isUnlimited(max)) return false;
    return used >= Number(max);
}
